import {GetterTree} from 'vuex';
import {CrudGetter} from '@/libs/core/crud/crud-getter';
import {CrudEntity} from '@/libs/core/crud/crud-service';
import {CrudPageInfo, CrudStoreState} from '@/libs/core/crud/crud-store-state';

type State = CrudStoreState<CrudEntity, CrudEntity>;

export const crudGetters: GetterTree<State, unknown> = {
    [CrudGetter.Pending]: state => (key?: string) => state.pending[key || ''] ?? false,
    [CrudGetter.Saving]: state => (key?: string) => state.saving[key || ''] ?? false,
    [CrudGetter.Deleting]: state => (key?: string) => state.deleting[key || ''] ?? false,
    [CrudGetter.Data]: state => (key?: string) => state.data[key || ''] ?? [],
    [CrudGetter.Detail]: state => (key?: string) => state.detail[key || ''] ?? null,
    [CrudGetter.PageInfo]: state => (key?: string) => state.pageInfo[key || ''] ?? new CrudPageInfo(),
    [CrudGetter.Sum]: state => (key?: string) => state.sum[key || ''] ?? null,
    [CrudGetter.GroupedData]: state => (key?: string) => state.groupedData[key || ''] ?? [],
};
